export default __webpack_public_path__ + "856c5a3c0ad6fa31ceae37f566e05ffc.png";